// extracted by mini-css-extract-plugin
export default {"containerSuccess":"SuccessMessage_containerSuccess__lJ4J7","buttonCheck":"SuccessMessage_buttonCheck__oLR8b"};